import React, { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import LandingPage from './pages/LandingPage';
import OrderPage from './pages/OrderPage';
import LepenyPage from './pages/LepenyPage'; // ✅ ÚJ!
import CustomizeModal from './components/CustomizeModal';
import cakesData from './data/cakesData.json';
import lepenyData from './data/lepenyData.json'; // ✅ ÚJ!
import './styles/global.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [cartItems, setCartItems] = useState([]);
  const [showCustomizeModal, setShowCustomizeModal] = useState(false);
  const [selectedCake, setSelectedCake] = useState(null);
  const [showOrderConfirmation, setShowOrderConfirmation] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [confirmedOrderNumber, setConfirmedOrderNumber] = useState('');
  const [customization, setCustomization] = useState({
    size: '8',
    ostya: 'none'
  });
  const [orderForm, setOrderForm] = useState({
    name: '',
    phone: '',
    email: '',
    pickupDate: '',
    notes: '',
    marketingConsent: false
  });

  // Scroll to top whenever page changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const { cakeTypes, sizes, ostyaOptions } = cakesData;
  const { lepenyTypes } = lepenyData; // ✅ ÚJ!

  const openCustomizeModal = (cake) => {
    setSelectedCake(cake);
    setCustomization({
      size: cake.isSpecial && cake.customSizes ? cake.customSizes[0].id : '8',
      ostya: 'none'
    });
    setShowCustomizeModal(true);
  };

  const closeCustomizeModal = () => {
    setShowCustomizeModal(false);
    setSelectedCake(null);
  };

  const calculatePrice = (cake, size, ostya) => {
    if (!cake) return 0;
    
    // Ha formatorta (isSpecial), használd a customSizes-t
    if (cake.isSpecial && cake.customSizes) {
      const sizeOption = cake.customSizes.find(s => s.id === size);
      return sizeOption ? sizeOption.price : 0;
    }
    
    // Ha hagyományos torta
    const sizeOption = sizes.find(s => s.id === size);
    if (!sizeOption) return 0;
    
    let ostyaPrice = 0;
    if (ostya !== 'none') {
      // Determine ostya price based on cake size
      if (sizeOption.pieces < 20) {
        ostyaPrice = 1500;
      } else {
        ostyaPrice = 2000;
      }
    }
    
    return sizeOption.price + ostyaPrice;
  };

  const addToCart = () => {
    if (!selectedCake) return;

    // Ha formatorta
    if (selectedCake.isSpecial) {
      const sizeOption = selectedCake.customSizes.find(s => s.id === customization.size);
      
      const cartItem = {
        id: `${selectedCake.id}-${customization.size}-${Date.now()}`,
        cakeId: selectedCake.id,
        name: selectedCake.name,
        image: selectedCake.image,
        size: sizeOption.name,
        pieces: sizeOption.pieces || 0,
        ostya: 'Nincs ostyakép',
        price: sizeOption.price,
        quantity: 1
      };

      setCartItems([...cartItems, cartItem]);
      
    } else {
      // Hagyományos torta
      const sizeOption = sizes.find(s => s.id === customization.size);
      const price = calculatePrice(selectedCake, customization.size, customization.ostya);
      
      const cartItem = {
        id: `${selectedCake.id}-${customization.size}-${customization.ostya}`,
        cakeId: selectedCake.id,
        name: selectedCake.name,
        image: selectedCake.image,
        size: sizeOption.name,
        pieces: sizeOption.pieces,
        ostya: customization.ostya !== 'none' ? 'Ostyakép' : 'Nincs ostyakép',
        price: price,
        quantity: 1
      };

      const existingItem = cartItems.find(item => item.id === cartItem.id);
      if (existingItem) {
        setCartItems(cartItems.map(item => 
          item.id === cartItem.id ? { ...item, quantity: item.quantity + 1 } : item
        ));
      } else {
        setCartItems([...cartItems, cartItem]);
      }
    }
    
    closeCustomizeModal();
  };

  const removeFromCart = (cakeId) => {
    setCartItems(cartItems.filter(item => item.id !== cakeId));
  };

  const updateQuantity = (cakeId, newQuantity) => {
    if (newQuantity === 0) {
      removeFromCart(cakeId);
    } else {
      setCartItems(cartItems.map(item =>
        item.id === cakeId ? { ...item, quantity: newQuantity } : item
      ));
    }
  };

  // ✅ ÚJ: Lepény kosárba rakása
  const addLepenyToCart = (lepeny) => {
    const cartItem = {
      id: `lepeny-${lepeny.id}`,
      cakeId: lepeny.id,
      name: lepeny.name,
      image: lepeny.image,
      size: 'Normál',
      ostya: 'Nincs',
      price: lepeny.price,
      quantity: 1
    };

    const existingItem = cartItems.find(item => item.id === cartItem.id);
    if (existingItem) {
      setCartItems(cartItems.map(item => 
        item.id === cartItem.id ? { ...item, quantity: item.quantity + 1 } : item
      ));
    } else {
      setCartItems([...cartItems, cartItem]);
    }
  };

  const totalPrice = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  const handleSubmitOrder = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('/config.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customerData: orderForm,
          cartItems: cartItems,
          totalPrice: totalPrice
        })
      });

      const data = await response.json();

      if (data.success) {
        setCustomerName(orderForm.name);
        setConfirmedOrderNumber(data.orderNumber || 'N/A');
        setShowOrderConfirmation(true);
        setCartItems([]);
        setOrderForm({ 
          name: '', 
          phone: '', 
          email: '', 
          pickupDate: '', 
          notes: '',
          marketingConsent: false 
        });
        
        // Hide confirmation after 8 seconds
        setTimeout(() => {
          setShowOrderConfirmation(false);
          setConfirmedOrderNumber('');
        }, 8000);
      } else {
        alert('Hiba történt a rendelés során: ' + (data.error || 'Kérjük, próbálja újra!'));
      }
    } catch (error) {
      console.error('Order submission error:', error);
      alert('Nem sikerült kapcsolódni a szerverhez. Kérjük, ellenőrizze az internetkapcsolatot!');
    }
  };

  const cartItemsCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <LandingPage setCurrentPage={setCurrentPage} />;
      
      case 'order':
        return (
          <OrderPage 
            cakeTypes={cakeTypes}
            cartItems={cartItems}
            orderForm={orderForm}
            setOrderForm={setOrderForm}
            openCustomizeModal={openCustomizeModal}
            updateQuantity={updateQuantity}
            handleSubmitOrder={handleSubmitOrder}
            totalPrice={totalPrice}
            
            // ✅ HIÁNYZÓ PROPS - EZEK KELLENEK!
            isModalOpen={showCustomizeModal}
            setIsModalOpen={setShowCustomizeModal}
            selectedCake={selectedCake}
            addToCart={addToCart}
            globalSizes={sizes}
            globalOstya={ostyaOptions}
          />
        );
      
      // ✅ ÚJ: Lepény oldal
      case 'lepenyek':
        return (
          <LepenyPage 
            lepenyTypes={lepenyTypes}
            cartItems={cartItems}
            orderForm={orderForm}
            setOrderForm={setOrderForm}
            addLepenyToCart={addLepenyToCart}
            updateQuantity={updateQuantity}
            handleSubmitOrder={handleSubmitOrder}
            totalPrice={totalPrice}
          />
        );
      
      default:
        return <LandingPage setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <div className="bakery-app">
      <Navigation 
        currentPage={currentPage} 
        setCurrentPage={setCurrentPage} 
        cartItemsCount={cartItemsCount}
      />

      {renderPage()}

      {showCustomizeModal && (
        <CustomizeModal 
          selectedCake={selectedCake}
          customization={customization}
          setCustomization={setCustomization}
          sizes={selectedCake?.isSpecial ? selectedCake.customSizes : sizes}
          ostyaOptions={ostyaOptions}
          calculatePrice={calculatePrice}
          addToCart={addToCart}
          closeCustomizeModal={closeCustomizeModal}
          allCakeTypes={cakeTypes}
        />
      )}

      {showOrderConfirmation && (
        <div className="order-confirmation-overlay">
          <div className="order-confirmation-box">
            <div className="confirmation-icon">✓</div>
            <h2>Rendelés Megerősítve!</h2>
            <p>Köszönjük a rendelését, <strong>{customerName}</strong>!</p>
            
            {confirmedOrderNumber && (
              <div className="order-number-display">
                <p className="order-number-label">Rendelésszám:</p>
                <p className="order-number-value">{confirmedOrderNumber}</p>
                <p className="order-number-hint">Kérjük, jegyezze fel ezt a számot!</p>
              </div>
            )}
            
            <p className="confirmation-message">
              Emailben elküldtük a rendelés részleteit és a rendelésszámot.
            </p>
            
            {cartItems.some(item => item.ostya.includes('Ostyakép')) && (
              <p className="confirmation-email-note">
                📧 Rendelt <strong>ostyaképet</strong>, külön emailt kap a kép feltöltéséről!
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;